import * as React from 'react'
import {Box, TextField} from '@mui/material'
import {makeOcStyles} from '@oc/styles'
import {SearchIcon} from '@oc/icons'
import {FixedSizeList, ListProps} from 'react-window'
import {useStateWithDebounce} from '@oc/hooks'
import {DisplayLanguage, OcLanguagesListRowRenderer} from './OcLanguagesListRowRenderer'
import {wrapAgGridCellComponentObservable} from '../AgGrid'

const useStyles = makeOcStyles(theme => ({
    languagesSearchTextFiled: {
        margin: theme.spacing(2)
    },
    searchIcon: {
        marginRight: theme.spacing(1)
    }
}))

export type AdditionalVirtualListProps =
    | Omit<ListProps<DisplayLanguage[]>, 'width' | 'height' | 'rowHeight'>
    | undefined

export interface OcLanguagesMenuItemProps {
    selectedLanguage: DisplayLanguage
    suggestions: DisplayLanguage[]
    onChangeHandler: (suggestion?: DisplayLanguage) => void
    onSearchHandler: (searchTerm: string) => void
    showFilter: boolean
    width: number
    height: number
    rowHeight: number
    searchLabel: string
    additionalVirtualListProps?: AdditionalVirtualListProps
}

// don't remove ref, MUI.Menu expects it to be there
function _OcLanguagesMenuItems(props: OcLanguagesMenuItemProps, _ref: React.Ref<unknown>) {
    const {
        suggestions,
        onChangeHandler,
        selectedLanguage,
        onSearchHandler,
        showFilter,
        width,
        height,
        rowHeight,
        searchLabel,
        additionalVirtualListProps
    } = props
    const {classes} = useStyles()
    const [filter, setFilter] = useStateWithDebounce<string>('', onSearchHandler, 500)

    const selectedLanguageIndex = React.useMemo(() => {
        return suggestions.findIndex(i => i.key === selectedLanguage.key) || 0
    }, [suggestions, selectedLanguage.key])

    return (
        <Box>
            {showFilter && (
                <Box className={classes.languagesSearchTextFiled}>
                    <TextField
                        id="oc-languages-selection-search"
                        fullWidth
                        value={filter}
                        onChange={e => {
                            setFilter(e.target.value)
                        }}
                        label={searchLabel}
                        slotProps={{
                            input: {
                                startAdornment: <SearchIcon className={classes.searchIcon} size="16px" />
                            }
                        }}
                    />
                </Box>
            )}
            <Box>
                <FixedSizeList
                    // TOMAS test how it looks
                    width={width}
                    height={height}
                    itemCount={suggestions.length}
                    itemSize={rowHeight}
                    itemData={suggestions}
                    initialScrollOffset={rowHeight * selectedLanguageIndex} // TOMAS is it count in pixels or in items?
                    {...additionalVirtualListProps}
                >
                    {props => (
                        <OcLanguagesListRowRenderer
                            key={props.data[props.index].key}
                            style={props.style}
                            language={props.data[props.index]}
                            onChangeHandler={onChangeHandler}
                            selectedLanguage={selectedLanguage}
                        />
                    )}
                </FixedSizeList>
            </Box>
        </Box>
    )
}

// HACK: React props type is lost when observer(Component, {forwardRef: true}) is used
export const OcLanguagesMenuItems = wrapAgGridCellComponentObservable(_OcLanguagesMenuItems)
